import { useCallback } from 'react'

import { useAsync } from 'core/ui/hooks/useAsync'

import { useConfigContext } from 'config/ui/ConfigContext'

import { DocumentType } from '../../domain/Document'
import { uploadDocument } from '../../use-cases/uploadDocument'

export function useUploadDocument() {
  const configs = useConfigContext()
  const enableAttachmentsEndpointForPods = configs.enableAttachmentsEndpointForPods.toBoolean()
  const enableProofOfPickup = configs.enableProofOfPickup.toBoolean()

  const uploadDocumentWithFlag = useCallback(
    async (params: Parameters<typeof uploadDocument>[0]) => {
      if (params.documentType === DocumentType.ProofOfPickup && !enableProofOfPickup) {
        throw new Error('Proof of Pickup is not enabled')
      }

      return uploadDocument({ ...params, enableAttachmentsEndpointForPods, enableProofOfPickup })
    },
    [enableAttachmentsEndpointForPods, enableProofOfPickup]
  )

  const { call, reset, status, isInitial, isPending, isDone, hasError } =
    useAsync(uploadDocumentWithFlag)
  return { uploadDocuments: call, reset, status, isInitial, isPending, isDone, hasError }
}
